import { ISetSuppliersPage, ISupplierState } from '../reducers/selectionOfSuppliers';
import { ActionTypes } from '../types/actionTypes';
import { ISetSuppliers } from '../types/actions';

// eslint-disable-next-line import/prefer-default-export
export const setSuppliers = (payload: ISupplierState): ISetSuppliers => ({
  type: ActionTypes.SET_SUPPLIERS,
  payload,
});
export const setSuppliersPage = (payload: number): ISetSuppliersPage => ({
  type: ActionTypes.SET_SUPPLIERS_PAGE,
  payload,
});
export const setSuppliersSearchId = (payload: number) => ({
  type: ActionTypes.SET_SUPPLIERS_SEARCH_ID,
  payload,
});

export const setSuppliersSearchErrors = (payload: string) => ({
  type: ActionTypes.SET_SUPPLIERS_SEARCH_ERRORS,
  payload,
});
